import dayjs from "dayjs";
import { ISalaryDeductionPlan } from "us.collection.case/interfaces";
import { SalaryDeductionSchedules } from "us.collection.case/constants";

export const salaryDeductionPlan : ISalaryDeductionPlan = {
    caseId: "",
    enforcementId: -1,
    fromDate: dayjs(),  /* Start date for the Salary Deduction Plan */
    deductionSchedule: SalaryDeductionSchedules.MONTHLY, /* Possible values = {Weekly,BiWeekly,Monthly} */
    deductionAmount: 0,
    faceValue: 0, 
    isGiroTemplate: false,
    nextInstallmentDate: dayjs(),
    nextTermAmount: "0",
    saveToDB: false, /* false- salary deduction schema is calculated without saving to DB. true - given salary deduction schema is saved to db*/
    salaryDeductionSchema: []
}